var colors = [
    {
        fillColor: 'rgba(98, 168, 234, .1)',
        strokeColor: 'green',
        pointColor: 'green',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'green',
        highlightFill: '#fff',
        highlightStroke: 'green'
    },
    {
        fillColor: "rgba(204, 213, 219, .1)",
        strokeColor: 'blue',
        pointColor: 'blue',
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: 'blue',
        highlightFill: '#fff',
        highlightStroke: 'blue'
    },
    {
        fillColor: 'rgba(98, 168, 234, .1)',
        strokeColor: 'green',
        pointColor: 'green',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'green',
        highlightFill: '#fff',
        highlightStroke: 'green'
    },
    {
        fillColor: "rgba(204, 213, 219, .1)",
        strokeColor: 'blue',
        pointColor: 'blue',
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: 'blue',
        highlightFill: '#fff',
        highlightStroke: 'blue'
    },
    {
        fillColor: 'rgba(98, 168, 234, .1)',
        strokeColor: 'green',
        pointColor: 'green',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'green',
        highlightFill: '#fff',
        highlightStroke: 'green'
    },
    {
        fillColor: "rgba(204, 213, 219, .1)",
        strokeColor: 'blue',
        pointColor: 'blue',
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: 'blue',
        highlightFill: '#fff',
        highlightStroke: 'blue'
    },
    {
        fillColor: 'rgba(98, 168, 234, .1)',
        strokeColor: 'green',
        pointColor: 'green',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'green',
        highlightFill: '#fff',
        highlightStroke: 'green'
    },
    {
        fillColor: "rgba(204, 213, 219, .1)",
        strokeColor: 'blue',
        pointColor: 'blue',
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: 'blue',
        highlightFill: '#fff',
        highlightStroke: 'blue'
    },
    {
        fillColor: 'rgba(98, 168, 234, .1)',
        strokeColor: 'green',
        pointColor: 'green',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'green',
        highlightFill: '#fff',
        highlightStroke: 'green'
    },
    {
        fillColor: "rgba(204, 213, 219, .1)",
        strokeColor: 'blue',
        pointColor: 'blue',
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: 'blue',
        highlightFill: '#fff',
        highlightStroke: 'blue'
    },
    {
        fillColor: 'rgba(98, 168, 234, .1)',
        strokeColor: 'green',
        pointColor: 'green',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'green',
        highlightFill: '#fff',
        highlightStroke: 'green'
    },
    {
        fillColor: "rgba(204, 213, 219, .1)",
        strokeColor: 'blue',
        pointColor: 'blue',
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: 'blue',
        highlightFill: '#fff',
        highlightStroke: 'blue'
    }
];

var Charter = {
    
    line: $.proxy(function (selector, labels, data, options) {
        return this.draw('line', selector, labels, data, options);
    }, Charter),
    
    bar: $.proxy(function (selector, labels, data, options) {
        return this.draw('bar', selector, labels, data, options);
    }, Charter),
    
    pie: $.proxy(function (selector, data, options) {
        options = options || {};
        
        $.extend(options, {
            responsive: true
        });
        
        return new Chart($(selector)[0].getContext("2d")).Pie(data, options);
    }, Charter),
    
    draw: function (type, selector, labels, data, options) {
        options = options || {};
        
        var dataSets = [];
        
        $.each(data, function (index, element) {
            if (typeof element.label == 'undefined'){
                dataSets.push( 
                    $.extend({
                        data: element
                    }, colors[index])
                );
            } else {
                dataSets.push(
                    $.extend(colors[index],element)
                );
            }
        });
        var chartData = {
            labels: labels,
            scaleShowGridLines: true,
            scaleShowVerticalLines: false,
            scaleGridLineColor: "#ebedf0",
            datasets: dataSets
        };

        $.extend(options, {
            responsive: true,
        });

        return new Chart($(selector)[0].getContext("2d"))[type.capitalize()](chartData, options);
    }
    
};

module.exports = Charter;


// WEBPACK FOOTER //
// ./resources/scripts/portal/modules/Charter.js